export default defineNuxtPlugin(() => {
  const globalStore = useGlobalStore();
  globalStore.parseUserAgent();
});
